import { Component, OnInit, Input } from '@angular/core';

import { WizardService } from '../../../../services/wizard/wizard.service';
import { IWizardContact } from '../../../../models';

// TODO-COMMON
// import { IUser } from '@app/core/interfaces';

import * as _ from 'lodash';
import moment_ from 'moment-timezone';
const moment = moment_;

/**
 * Displayed before booking a meeting, without sending invitations to request a time first
 */
@Component({
    selector: 'wizard-booking-confirmation',
    templateUrl: './booking-confirmation.component.html',
    styleUrls: ['./booking-confirmation.component.scss', '../confirmation.component.scss', '../../../form-styles.scss']
})
export class BookingConfirmationComponent implements OnInit {
    @Input() availabilityUsers: IWizardContact[];
    @Input() availabilityTypeText = '';
    @Input() selectedContacts: any[];
    @Input() vipContacts: IWizardContact[];
    @Input() currentUser: any;
    @Input() isUpdatingMeeting = false;
    @Input() timezone = moment.tz.guess();

    constructor(public wizardService: WizardService) {}

    ngOnInit() {}
}
